/** Target UX durations shown in loading placeholders (countdown + progress bar). */
export const PORTRAIT_GENERATION_SECONDS = 12;
export const IMAGE_GENERATION_SECONDS = 20;
export const VIDEO_GENERATION_SECONDS = 60;
